document.addEventListener("DOMContentLoaded", function () {
  const bar = document.querySelector("#shopify-section-top-info-bar .marquee-container p");
  if (!bar) return;

  // Divs you want to toggle
  const defaultDiv = document.querySelector('[data-rid="4e0df067-3a2d-4fc6-91d6-86fd52915f1d"]');
  const promoDiv   = document.querySelector('[data-rid="d317fa0f-0625-4b58-9565-2171ed3e9dca"]');

  // --- Get current PST time ---
  const now = new Date();

  const laborDayStart = new Date("2025-09-04T00:00:00-08:00");
  const laborDayEnd   = new Date("2026-09-07T23:59:59-08:00");

  let message = "FREE SHIPPING FOR US ORDERS OVER $50";
  let promoActive = false;

  // --- Promo logic ---
  if (now >= laborDayStart && now <= laborDayEnd) {
    message = "TAKE $25 OFF ORDERS OF $100+ — USE CODE LDW25";
    promoActive = true;
  }

  // Update Banner Message
  bar.innerHTML = message;

  // --- Toggle the divs based on promo status ---
  if (defaultDiv && promoActive === false) {
    defaultDiv.style.display = "flex";
  } 
  if (defaultDiv && promoActive === true) {
    defaultDiv.style.display = "none";
  }

  if (promoDiv && promoActive === true) {
    promoDiv.style.display = "flex";
  } 
  if (promoDiv && promoActive === false) {
    promoDiv.style.display = "none";
  }

  console.log("Promo active:", promoActive, "→", message);
});
